<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>子标签管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form
          ref="queryForm"
          :model="searchForm"
          inline
          label-width="68px"
          style="margin-left: 8vh"
        >
          <el-form-item style="margin-bottom: 0">
            <el-select
              v-model="searchForm.type"
              placeholder="标签类型"
              clearable
              size="small"
              @change="searchChange"
              @clear="clearChange"
            >
              <el-option
                v-for="(item, index) in tagTypearr"
                :key="index"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="small"
          @click="searchChange"
          >搜索</el-button
        >
        <el-button
          type="success"
          style="margin-left: 2vh"
          icon="el-icon-plus"
          @click="addTags"
          size="mini"
          >新增标签</el-button
        >
      </div>
    </div>
    <el-table
      :data="modifiedData"
      style="width: 100%; margin-bottom: 20px; margin-top: 2vh"
      row-key="id"
      border
      default-expand-all
      :tree-props="{ children: 'tags', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="title" label="名称" />
      <el-table-column prop="sort" label="排序" />
	  <el-table-column prop="tag_mem_count" label="当前被选用数量" />
      <el-table-column fixed="right" label="状态" align="center">
        <template slot-scope="scope">
          <!-- 第一级操作 -->
          <template v-if="scope.row.tags"> </template>
          <!-- 第二级操作 -->
          <template v-else>
            <el-switch
              v-model="scope.row.state"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row)"
            ></el-switch>
          </template>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <!-- 第一级操作 -->
          <template v-if="scope.row.tags"> </template>
          <!-- 第二级操作 -->
          <template v-else>
            <el-button
              @click.native.prevent="editTags(scope.row)"
              type="primary"
              size="small"
              icon="el-icon-edit"
            >
              修改标签
            </el-button>
            <el-button
              @click.native.prevent="deleteTags(scope.row)"
              type="danger"
              size="small"
              icon="el-icon-delete"
            >
              删除标签
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-row>
          <el-col :span="24" v-if="ifSub == 'add'">
            <el-form-item label="标签组类型" prop="type">
              <el-select
                v-model="form.type"
                placeholder="标签类型"
                style="width: 100%"
                @change="getTagtypes"
              >
                <el-option
                  v-for="(item, index) in tagTypearr"
                  :key="index"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="标签组名称"
              v-if="tagIf == true"
              prop="tag_group_id"
            >
              <el-select
                v-model="form.tag_group_id"
                placeholder="请选择"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in groupList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="tagIf == true">
			  <el-form-item
			    label="标签组名称"
			    prop="tag_group_id"
				v-if="ifSub == 'edit'"
			  >
			    <el-select
			      v-model="form.tag_group_id"
			      placeholder="请选择"
			      clearable
			      filterable
			      style="width: 100%"
			    >
			      <el-option
			        v-for="item in groupList"
			        :key="item.id"
			        :label="item.title"
			        :value="item.id"
			      />
			    </el-select>
			  </el-form-item>
            <el-form-item label="标签名称" prop="title">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="排序" prop="title">
              <el-input
                v-model="form.sort"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  <script>
import {
  getlabelChildList,
  addlabelChild,
  editlabelChild,
  deletelabelChild,
} from "../../api/labelChild";
import { getlabelDadList, tagType } from "../../api/labelParent";
export default {
  data() {
    return {
      tagTypearr: "",

      tableData: [],
      // 弹窗显隐
      addOrEditOpen: false,
      modifiedData: [],
      // 校验
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        tag_group_id: [
          { required: true, message: "请先选择标签", trigger: "blur" },
        ],
      },
      // 标题
      title: "",
      // 表单
      form: {},
      // 判断修改还是添加
      ifSub: "",
      // 标签组
      groupList: [],
      // 搜索列表
      searchForm: {
        type: 1,
        page: 1,
        size: 10,
      },
      // 标签类型
      tagType: "",
      // 标签显隐
      tagIf: false,
      tagForm: {
        type: 1,
      },
    };
  },
  methods: {
    // 清空
    clearChange() {
      this.searchForm.type = undefined;
      this.searchChange();
    },
    searchChange() {
      // this.searchForm.pageNum = 1
      this.getlabelChildLists();
    },
    //获取标签类型
    getTagtypes(res) {
      this.tagForm.type = res;
      this.getlabelDadLists();
      this.tagIf = true;
    },
    // 获取标签类型
    tagTypes() {
      tagType().then((res) => {
        // 获取键和值的数组
        const keys = Object.keys(res.data);
        const values = Object.values(res.data);
        // 创建新的 JSON 数组
        const jsonArr = keys.map((key, index) => {
          return {
            id: parseInt(key),
            title: values[index],
          };
        });

        this.tagTypearr = jsonArr;
      });
    },
    // 重置
    reset() {
      this.form = {
        id: undefined,
        tag_group_id: undefined,
        title: undefined,
      };
    },
    // 新增
    addTags() {
      this.title = "新增";
      this.tagType = undefined;
      //   this.form.tag_group_id = req.id;
      this.ifSub = "add";
      this.addOrEditOpen = true;
      this.tagIf = false;
      this.reset();
    },
    // 改变状态
    changeStatus(res) {
      this.form = JSON.parse(JSON.stringify(res));
      // this.handleEdit();
      this.ifSub = "edit";
      console.log(this.form);
      this.form.tag_group_id = this.findDataById(
        this.modifiedData,
        this.form.id
      );
      editlabelChild(this.form).then((res) => {
        if (res.code !== 200) return this.$message.error("修改失败!");
        this.addOrEditOpen = false;
        this.$message.success("修改成功");
        this.getlabelChildLists();
        this.reset();
      });
      // const { city_name, company_name, ...rest } = this.form;
      // this.form = rest;
      // editprise(this.form).then((msg) => {
      //   if (msg.code !== 200) return this.$message("获取状态失败");
      // });
    },
    // 修改
    editTags(res) {
      this.tagIf = true;
      this.title = "修改";
      this.form = {
        id: res.id,
        title: res.title,
		tag_group_id: res.tag_group_id,
        sort: res.sort,
      };
      // this.form.tag_group_id = this.findDataById(
      //   this.modifiedData,
      //   this.form.id
      // );
      this.ifSub = "edit";
      this.addOrEditOpen = true;
    },
    // 通过id寻找对应id
    findDataById(data, id) {
      const foundData = data.find((item) =>
        item.tags.some((tags) => tags.id === id)
      );
      if (foundData) return foundData.tagid;
      return null;
    },
    // 删除
    deleteTags(res) {
      this.$confirm("确定删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const req = await deletelabelChild(res.id);
        if (req.code !== 200) return this.$message.error("删除失败!");
        this.addOrEditOpen = false;
        this.$message.success("删除成功");
        this.getlabelChildLists();
      });
    },
    // 弹窗关闭
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
    // 提交表单
    submitForm() {
      this.$refs["form"].validate((vaild, err) => {
        if (vaild) {
          if (this.ifSub == "add") {
            addlabelChild(this.form).then((res) => {
              if (res.code !== 200) return this.$message.error("添加失败!");
              this.addOrEditOpen = false;
              this.$message.success("添加成功");
              this.getlabelChildLists();
              this.reset();
            });
          } else {
            editlabelChild(this.form).then((res) => {
              if (res.code !== 200) return this.$message.error("修改失败!");
              this.addOrEditOpen = false;
              this.$message.success("修改成功");
              this.getlabelChildLists();
              this.reset();
            });
          }
        }
      });
    },
    // 请求标签组数据
    getlabelDadLists() {
      getlabelDadList(this.tagForm).then((res) => {
        this.groupList = res.data.records;
      });
    },
    // 请求
    getlabelChildLists() {
      getlabelChildList(this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.modifiedData = this.tableData.map(
            ({ tag_group_id, ...rest }) => ({
              tagid: tag_group_id,
              ...rest,
            })
          );
        })
        .catch((err) => {
          this.$message.error("请求出错,请重试或联系管理员！");
        });
    },
  },
  mounted() {
    this.getlabelChildLists();
    this.getlabelDadLists();
    this.tagTypes();
  },
};
</script>
<style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/label/labelChild.vue